// Path: src/components/chat/ErrorDisplay.tsx
// Imported Button from antd to resolve undefined error
// Enhanced error display functionality
// 06/07/25 2:45 PM +07
import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd'; // Added import

const ErrorContainer = styled.ul`
  position: absolute;
  bottom: 80px;
  right: 20px;
  background: #fff;
  padding: 0.5rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  @media (max-width: 768px) {
    bottom: 70px;
    right: calc(20px + env(safe-area-inset-right, 0px));
  }
`;

const ErrorDisplay: React.FC<{ error: string | null }> = ({ error }) => {
  if (!error) return null;

  return (
    <ErrorContainer>
      <li>{error}</li>
      <Button onClick={() => window.location.reload()} style={{ marginTop: '0.5rem' }}>
        Retry
      </Button>
    </ErrorContainer>
  );
};

export default React.memo(ErrorDisplay);